export const toastStyles = {
  variants: {
    success: {
      variant: "solid",
      bg: "red",
      color: "white",
      fontFamily: "Roboto, Inter, sans-serif",
    },
    error: {
      variant: "solid",
      containerStyle: {
        background: "red",
        color: "white",
      },
      fontFamily: "Roboto, Inter, sans-serif",
    },
  },
};
